'use strict';

module.exports = function (_ref) {
  var autoSize = _ref.autoSize,
      isTitle = _ref.isTitle;
  var classNames = ['modal-main'];
  if (autoSize) classNames.push('modal-autosize');
  if (isTitle) classNames.push('modal-is-title');
  return classNames.join(' ');
};